<div class="table-responsive scrollbar">
  <table class="table table-bordered table-striped fs-10 mb-0">
    <thead class="bg-200">
      <tr>
        @for (col of columns(); track col){

        <th
          (click)="sort(col)"
          class="text-900 sort cursor-pointer"
          [attr.data-sort]="col.key"
        >
          {{ col.label }}
          @if (col.sortable) {
          <span>
            @if (isSortedAsc(col)) { ▲ } @else if (isSortedDesc(col)) { ▼ }
          </span>
          }
        </th>
        }
      </tr>
    </thead>
    <tbody class="list">
      @for (row of pagedData; track row) {
      <tr>
        @for (col of columns(); track col) {
        <td [ngClass]="col.key">
          @if (col.template) {
          <ng-container
            *ngTemplateOutlet="col.template; context: { $implicit: row }"
          ></ng-container>
          } @else {
          {{ row[col.key] }}
          }
        </td>
        }
      </tr>
      }
    </tbody>
  </table>
</div>

@if(!!pageSize()) {
<div class="d-flex justify-content-center mt-3">
  <button
    class="btn btn-sm btn-falcon-default me-1"
    (click)="changePage(-1)"
    [disabled]="currentPage === 1"
    title="Previous"
  >
    <span class="fas fa-chevron-left"></span>
  </button>

  <ul class="pagination mb-0">
    <li
      *ngFor="let item of getPaginationItems()"
      class="page-item"
      [class.active]="item.isCurrent"
    >
      <a
        class="page-link"
        *ngIf="item.display !== '...'; else ellipsis"
        (click)="goToPage(item.display)"
        style="cursor: pointer"
      >
        {{ item.display }}
      </a>
      <ng-template #ellipsis>
        <a
          class="page-link"
          (click)="goToPage(item.jumpTo!)"
          style="cursor: pointer"
        >
          …
        </a>
      </ng-template>
    </li>
  </ul>

  <button
    class="btn btn-sm btn-falcon-default ms-1"
    (click)="changePage(1)"
    [disabled]="currentPage === totalPages"
    title="Next"
  >
    <span class="fas fa-chevron-right"></span>
  </button>
</div>
}
